import "./Help.scss";
import React from "react";

import {
  IonContent,
  IonList,
  IonPage,
  IonItem,
  IonIcon,
  IonLabel,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
import PrivateHeader from "../../components/PrivateHeader";
import sadFace from "../../assets/svg/sad-face.svg";
import bulbIdea from "../../assets/images/bulb-idea.png";

const Help: React.FC = React.memo(() => {
  const history = useHistory();

  return (
    <IonPage className="help-page">
      <PrivateHeader title="Help" />

      <IonContent>
          <IonList>
            <IonItem 
              lines="full" 
              button 
              detail={false}
              onClick={() => {
                history.push(`/report`);
              }}>
              <IonIcon
                icon={sadFace}
                slot="start"
                color="medium"
              />
               <IonLabel mode="ios">
                  <h3>
                    Having trouble?
                  </h3>
                  <p>Report it</p>
                </IonLabel>
            </IonItem>
            <IonItem 
              lines="full" 
              button 
              detail={false}
              onClick={() => {
                history.push(`/suggest-feature`);
              }}>
              <img
                src={bulbIdea}
                slot="start"
                className="bulb-img"
                alt="bulb idea"
              />
               <IonLabel mode="ios">
                  <h3>
                    Got an idea?
                  </h3>
                  <p>Suggest a feature</p>
                </IonLabel>
            </IonItem>
          </IonList>
      </IonContent>
    </IonPage>
  );
});

export default Help;
